// Path scheme for the public, shareable read-only tournament view. A single
// place builds and parses `/view/:id` so the QR/share link, the copy-to-
// clipboard URL, and the client-side route resolver (`main.tsx`) all agree.
// Kept framework-free so it can be unit-tested in isolation.

const PREFIX = '/view/';

/** In-app path for a tournament's public view, e.g. "/view/Tournament_abc". */
export function publicViewPath(tournamentId: string): string {
  return `${PREFIX}${encodeURIComponent(tournamentId)}`;
}

/**
 * Extract the tournament id from a public-view pathname, or null when the path
 * is not a public-view route. Accepts an optional trailing slash and rejects
 * anything with extra path segments so only `/view/<id>` resolves.
 */
export function parsePublicViewPath(pathname: string): string | null {
  if (!pathname.startsWith(PREFIX)) return null;
  const rest = pathname.slice(PREFIX.length).replace(/\/+$/, '');
  if (rest.length === 0 || rest.includes('/')) return null;
  try {
    const id = decodeURIComponent(rest);
    return id.length > 0 ? id : null;
  } catch {
    return null; // malformed percent-encoding
  }
}

/** Absolute share URL (origin + path) used by the QR code and copy button. */
export function publicViewUrl(tournamentId: string, origin: string): string {
  return `${origin}${publicViewPath(tournamentId)}`;
}
